import { useContext, useEffect, useState } from 'react';
import { useUpsertAccountFlag } from '../../../../sdk/ams/account/UseUpsertAccountFlag';
import { useRefreshAccountId } from '../../../../sdk/ams';
import { AccountContext } from '../../AccountContext';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { FormContainer, Select, SelectOption } from '@app/shared';
import DatePicker from 'react-datepicker';
import { CSSProperties } from 'styled-components';
import './AddFlag.css';
import { useFormatAndSendFlagRequest } from '../hooks/useUpsertFlag';
import { useAccountAvailableFlags } from '../../../../sdk/ams/account/UseAccountAvailableFlags';

export default function AddFlag() {
  return (
    <div className="ui segment">
      <div className="ui header">Add Flag To Account</div>
      <div className="content">
        <div className="ui form">
          <AccountFlagForm />
        </div>
      </div>
    </div>
  );
}

function AccountFlagForm() {
  const flexRowSpaceBetween: CSSProperties = { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' };
  const [minExpiryDate, setMinExpiryDate] = useState<Date | undefined>(new Date());
  const formContext = useForm<{
    key: string;
    effectiveDate?: string;
    expiryDate?: string;
  }>();

  const [selectData, setSelectData] = useState<SelectOption[]>([]);
  const { accountId, billingDate } = useContext(AccountContext);
  const { data: flags } = useAccountAvailableFlags();

  useEffect(() => {
    const mappedData = flags?.map((flag) => {
      return {
        label: flag.key,
        value: flag.key,
        tooltip: flag.description,
      };
    });
    if (flags) {
      setSelectData(mappedData);
    }
  }, [flags]);

  const { mutateAsync: upsertAccountFlag, isPending } = useUpsertAccountFlag();
  const refreshAccount = useRefreshAccountId(accountId);

  const onAddFlag = useFormatAndSendFlagRequest(accountId, upsertAccountFlag, refreshAccount);

  return (
    <FormProvider {...formContext}>
      <FormContainer
        isSubmitting={isPending}
        onSubmit={onAddFlag}>

        <Select
          options={{ required: 'Key is required' }}
          name="key"
          selectOptions={selectData}
          label="Key"
          defaultValue={''}
        />

{/* TODO: Uncomment once effective dates can be upserted, needs to be tested also in accordance with the contracts/requirements
         <Controller
          name="effectiveDate"
          control={formContext.control}
          render={({ field }) => (
            <div className="sixteen wide column" style={flexRowSpaceBetween}>
              <label className="ui label extra large datepicker-label">Effective date</label>
              <DatePicker
                name="effectiveDate"
                selected={field.value}
                onChange={(date) => {
                  field.onChange(date);
                }}
                dateFormat="dd/MM/yyyy"
                placeholderText="Effective date"
                minDate={billingDate}
                isClearable
              />
            </div>
          )}
        /> */}

        <Controller
          name="expiryDate"
          control={formContext.control}
          render={({ field }) => (
            <div className="sixteen wide column" style={flexRowSpaceBetween}>
              <label className="ui label extra large datepicker-label">Expiry date</label>
              <DatePicker
                name="expiryDate"
                selected={field.value}
                onChange={(date) => {
                  field.onChange(date);
                }}
                dateFormat="dd/MM/yyyy"
                placeholderText="Expiry date"
                minDate={minExpiryDate}
                isClearable
              />
            </div>
          )}
        />
      </FormContainer>
    </FormProvider>
  );
}
